'use strict';
var parent = require('../../stable/instance/slice');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/instance/slice.js
// module id = KJCo
// module chunks = 15